import { ArrowUpRight, Sparkles } from "lucide-react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/9f98c88e-72ad-4b82-ac02-e13b2896f919/images/bdb284f9da9d2ff03393ee932fd8cbacf5c2688c59ee526e69eaeded74e26a35.png";

const services = [
  "Web Development",
  "Social Media Management",
  "Live Streaming",
  "Graphic Designing",
];

export default function Hero() {
  return (
    <section id="home" data-testid="hero-section" className="relative min-h-screen flex items-end pt-28 pb-16 overflow-hidden">
      <img
        src={HERO_BG}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-90"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/85 to-[#050505]/40" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-transparent to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 md:px-10 w-full">
        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 md:col-span-9 min-w-0">
            <div
              data-testid="hero-eyebrow"
              className="mv-fade-up inline-flex items-center gap-2 border border-white/15 bg-white/5 backdrop-blur-md px-3 py-1.5 text-[10px] sm:text-[11px] uppercase tracking-[0.2em] sm:tracking-[0.25em] text-zinc-200 mb-6 md:mb-8 max-w-full"
              style={{ animationDelay: "0ms" }}
            >
              <Sparkles size={12} className="text-[#FF5A00] flex-shrink-0" />
              <span className="truncate">Mumbai's Trusted Digital Partner · Since 2015</span>
            </div>

            <h1
              data-testid="hero-heading"
              className="font-display mv-fade-up text-[36px] sm:text-5xl md:text-6xl lg:text-[84px] font-semibold leading-[1.05] tracking-tight break-words"
              style={{ animationDelay: "120ms" }}
            >
              Transform Your <span className="text-stroke">Business</span> with{" "}
              <span className="text-[#FF5A00]">Powerful</span> Digital Solutions
            </h1>

            <p
              data-testid="hero-subheading"
              className="mv-fade-up mt-6 md:mt-8 text-sm sm:text-base md:text-lg text-zinc-300 max-w-2xl leading-relaxed"
              style={{ animationDelay: "240ms" }}
            >
              From Web Development to Live Streaming, Mahaview Enterprises helps brands grow with
              innovative digital services — for businesses, creators, and organisations across India.
            </p>

            <div className="mv-fade-up mt-10 flex flex-col sm:flex-row gap-4" style={{ animationDelay: "360ms" }}>
              <a
                href="#contact"
                data-testid="hero-cta-button"
                className="mv-btn-primary inline-flex items-center gap-2 px-7 py-4 text-sm font-medium rounded-sm group"
              >
                Get Free Consultation
                <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
              <a
                href="#services"
                data-testid="hero-secondary-cta"
                className="inline-flex items-center gap-2 border border-white/20 hover:border-white/50 px-7 py-4 text-sm font-medium rounded-sm transition-colors"
              >
                View Services
              </a>
            </div>
          </div>

          <div className="col-span-12 md:col-span-3 hidden md:block">
            <div className="mv-fade-up border-l border-white/15 pl-6" style={{ animationDelay: "480ms" }}>
              <div className="text-[11px] uppercase tracking-[0.3em] text-zinc-400 mb-4">Est. 2015</div>
              <div className="space-y-2">
                <div className="text-3xl font-display font-semibold">10<span className="text-[#FF5A00]">+</span></div>
                <div className="text-xs text-zinc-400 uppercase tracking-[0.2em]">Years of Excellence</div>
              </div>
            </div>
          </div>
        </div>

        <div
          data-testid="hero-services-marquee"
          className="mv-fade-up mt-16 border-y border-white/10 py-5 overflow-hidden"
          style={{ animationDelay: "560ms" }}
        >
          <div className="flex whitespace-nowrap mv-marquee">
            {[...services, ...services, ...services].map((s, i) => (
              <span key={i} className="mx-8 text-sm md:text-base text-zinc-300 inline-flex items-center gap-8">
                {s}
                <span className="w-1.5 h-1.5 bg-[#FF5A00] rounded-full" />
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
